import { render, staticRenderFns } from "./barCode.vue?vue&type=template&id=6fab9054&scoped=true&"
import script from "./barCode.vue?vue&type=script&lang=js&"
export * from "./barCode.vue?vue&type=script&lang=js&"
import style1 from "./barCode.vue?vue&type=style&index=1&id=6fab9054&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab9054",
  null
  
)

export default component.exports